const ProjectArr = {
    CFPS: require(`./private-project/cfps`).default
}

class PrivateDeploy{
    static project = ProjectArr[process.env.PRIVATE_NAME]

    static isPrivate(){
        if(this.project){
            return true
        }else{
            return false
        }
    }

    static getPrivateRoutes(){
        return this.project.ROUTES
    }
    

    static getContactUsData() {
        return this.project.CONTACT_US
    }

    static getDefaultRedirect(){
        return this.project.DEFAULT_REDIRCT
    }
}

export {
    PrivateDeploy
}


// WEBPACK FOOTER //
// ./src/config/private-deploy.js